export default __webpack_public_path__ + "static/media/abOntimeLogo.b8680511.png";